import { Component, Input, ViewChild, Renderer2, ElementRef, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'user-plain-text',
    templateUrl: './renderUserMessage.component.html',
    styleUrls: ['./renderUserMessage.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RenderUserPlainText {

    @Input() data: any;

    @Input() inicialPosition: any;

    @ViewChild('chatMessage', {static: true}) chatMessage;

    @ViewChild('chatMessageItemContainer', {static: true}) chatMessageItemContainer

    @ViewChild('messageContentInit', {static: true}) messageContentInit;

    constructor(
        private _r: Renderer2,
        private _eL: ElementRef
    ) { }

    ngOnInit() {
        this.animationStart();
    }

    ngAfterViewInit() {
        this.checkParent();
    }

    /**
     * confere se o elemento anterior é um texto vindo do usuario
     */
    checkParent() {
        let parent = this._eL.nativeElement.previousElementSibling;

        if (parent && parent.tagName == "PLAIN-TEXT") {
            if (parent.firstChild.classList.contains("chat-message--right")) {
                this._r.addClass(this.chatMessage.nativeElement, 'text-sequence');
            }
        }
    }

    animationStart() {

        /**
         * Animacao de entrada com base na posicao do click do usuario na mensagem
         */
        this._r.setStyle(this.messageContentInit.nativeElement, 'position', 'fixed');
        this._r.setStyle(this.messageContentInit.nativeElement, 'opacity', '0');
        this._r.setStyle(this.messageContentInit.nativeElement, 'top', this.inicialPosition.top + 'px');
        this._r.setStyle(this.messageContentInit.nativeElement, 'left', this.inicialPosition.left + 'px');

        /**
         * anima o elemento em direcao ao content original
         */
        setTimeout(() => {
            this._r.setStyle(this.messageContentInit.nativeElement, 'top', this.chatMessageItemContainer.nativeElement.getBoundingClientRect().top + 'px');
            this._r.setStyle(this.messageContentInit.nativeElement, 'left', this.chatMessageItemContainer.nativeElement.getBoundingClientRect().right + 'px');
            this._r.setStyle(this.messageContentInit.nativeElement, 'opacity', '1');
        }, 200)

        /**
         * Finaliza a animacao voltando o elemento pra posicao original
         */
        setTimeout(() => {
            this._r.setStyle(this.messageContentInit.nativeElement, 'position', 'initial');
        }, 500)
    }
}
